import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const EmptyChartIconSvg = () => (
  <svg width="88" height="91" viewBox="0 0 88 91" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5">
      <rect y="23" width="24" height="68" rx="8" fill="#DCE0E6" />
      <rect x="32" y="45" width="24" height="46" rx="8" fill="#DCE0E6" />
      <rect x="64" width="24" height="91" rx="8" fill="#DCE0E6" />
    </g>
  </svg>
);

export const EmptyChartIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={EmptyChartIconSvg} {...props} />
);
